import { Chip } from '@mui/material'
import { KuType, KU_TYPES } from '../../types'

interface Props {
  type: KuType | null
  size?: 'small' | 'medium'
}

export default function KuBadge({ type, size = 'small' }: Props) {
  const meta = KU_TYPES.find((t) => t.value === type)
  if (!meta) return null
  return (
    <Chip
      label={meta.label}
      size={size}
      sx={{
        bgcolor: meta.color + '18',
        color: meta.color,
        fontWeight: 700,
        fontSize: 10,
        height: 20,
        borderRadius: '4px',
      }}
    />
  )
}
